import { Link } from "react-router-dom";

export default function PortfolioGrid() {
  const projects = [
    { slug: "kashima", title: "Kashima Website", projname: "Shipgirls Project", year: "2025", image: "https://i.imgur.com/TdD0Wjm.png", status: "ongoing" },
    { slug: "project-r ",title: "Project R", projname: "Indie Game", year: "2025", image: "https://imgur.com/mXzwKoo.png", status: "locked" },
    { slug: "syntax-of-the-dead", title: "Syntax of The Dead", projname: "Freelance Project", year: "2024", image: "/assets/SOTD_1combat.mp4", isVideo: true },
    { slug: "the-lost-wanderer", title: "The Lost Wanderer", projname: "Capstone Project", year: "2024", image: "https://i.imgur.com/ijhzMkZ.png" },
    { slug: "leap-of-faith-suit", title: "Leap of Faith Suit", projname: "Personal Project", year: "2022", image: "https://imgur.com/3Pa8aLM.png" },
    { title: "Power Digital Art", projname: "Fan Art", year: "2022", image: "https://i.imgur.com/uDTvlNP.jpeg" },
    { title: "Photo Study", projname: "Art", year: "2022", image: "https://i.imgur.com/Tp6D0m9.png" },
    { title: "Renaissance Period John Wick", projname: "Fan Art", year: "2021", image: "https://i.imgur.com/8reXcCl.png" },
  ];

  return (
    <div className="mx-auto px-8 mt-[1rem]">
      {/* Masonry Layout using CSS columns */}
      <div className="columns-1 sm:columns-2 lg:columns-3 gap-3 space-y-3">
        {projects.map((project, index) => (
          <div key={index} className="break-inside-avoid mb-3">
            {/* Image/Video Container */}
            {project.slug ? (
              <Link to={`/projects/${project.slug}`}>
                <div className="shadow-md rounded-md overflow-hidden bg-gray-100 dark:bg-[#1E1E1E] hover:shadow-[0_1px_25px_rgba(0,0,0,0.6)] transition-shadow duration-300">
                  {project.isVideo ? (
                    <video
                      src={project.image}
                      className="w-full object-cover"
                      autoPlay
                      loop
                      muted
                      playsInline
                    />
                  ) : (
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full object-cover"
                    />
                  )}
                </div>
              </Link>
            ) : (
              <div className="shadow-md rounded-md overflow-hidden bg-gray-100 dark:bg-[#1E1E1E]">
                {project.isVideo ? (
                  <video
                    src={project.image}
                    className="w-full object-cover"
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                ) : (
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full object-cover"
                  />
                )}
              </div>
            )}

            {/* Text Information */}
            <div className="mt-[.5rem] flex justify-between items-center">
              <div>
                <p className="text-xl font-medium text-[#424243] dark:text-white">{project.title}</p>
                <p className="text-xl text-gray-400 dark:text-[#acacac]">{project.projname}</p>
              </div>
              <p className="mt-[-1.5rem] text-lg text-gray-400 dark:text-[#acacac]">{project.year}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
